<template>
  <div class="member-list">
    <el-form :inline="true" :model="searchForm">
      <el-form-item>
        <el-button type="primary" size="mini" @click="getData">查询</el-button>
        <el-button type="primary" size="mini" @click="onCreate">添加会员</el-button>
      </el-form-item>
    </el-form>
    <el-table
      max-height="500px"
      :data="tableData"
      style="width: 100%">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="NO"></el-table-column>
      <el-table-column prop="photo" label="会员照片">
        <template slot-scope="scope">
          <el-avatar size="small" :src="scope.row.photo?'/api/'+scope.row.photo:defaultHeadPicSrc"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="会员姓名"></el-table-column>
      <el-table-column prop="sex" label="性别">
        <template slot-scope="scope">
          {{scope.row.sex == "1" ? "男":"女"}}
        </template>
      </el-table-column>
      <el-table-column prop="iphone" label="手机号码" show-overflow-tooltip></el-table-column>
      <el-table-column prop="deptId" label="归属门店"  show-overflow-tooltip>
        <template slot-scope="scope">
          {{getCookie("deptName")}}
        </template>
      </el-table-column>
      <el-table-column label="联系地址" :formatter="addressMatter" show-overflow-tooltip></el-table-column>
      <el-table-column prop="registerDate" label="注册日期" :formatter="dateMatter"></el-table-column>
      <el-table-column prop="isWork" label="会员资格">
        <template slot-scope="scope">
          {{scope.row.isWork == "0"?"无":(scope.row.isWork == "1"?"有效":"已过期")}}
        </template>
      </el-table-column>
      <el-table-column prop="consumeMoney" label="消费金额"></el-table-column>
      <el-table-column prop="validityDate" label="会员到期日" :formatter="dateMatter"></el-table-column>
      <el-table-column
        label="操作"
        >
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="editRow(scope.row)"
            type="text"
            size="small">
            编辑
          </el-button>
          <el-button
            @click.native.prevent="deleteRow(scope.row)"
            type="text"
            size="small">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
      <el-form ref="form" :model="formData" :rules="rules" label-width="120px" style="margin-right: 40px">
        <el-form-item label="会员姓名" prop="name">
          <el-input v-model="formData.name" placeholder="请输入名称，10字以内"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio v-model="formData.sex" label="1">男</el-radio>
          <el-radio v-model="formData.sex" label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker
            v-model="formData.birthDate"
            type="date"
            placeholder="请选择出生日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="身份证号码" prop="idCard">
          <el-input v-model="formData.idCard" placeholder="请输入身份证号"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="iphone">
          <el-input v-model="formData.iphone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="联系地址" prop="provinceAndCityAndCounty">
          <el-cascader
            clearable
            style="width: 100%"
            v-model="formData.provinceAndCityAndCounty"
            :options="provinceAndCityAndCountyOption"
            placeholder="请选择省市县"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="detailAddress">
          <el-input v-model="formData.detailAddress" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item label="会员照片">
          <el-upload
            action="#"
            :multiple="false"
            :limit="1"
            list-type="picture-card"
            :auto-upload="false"
            :on-change="handleUploadSuccess"
            :on-remove="handleRemove"
            :file-list="fileImageList">
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="归属门店">
          <el-select style="width: 100%" v-model="formData.deptId" placeholder="请选择" disabled>
            <el-option
              v-for="item in deptList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放会员卡">
          <el-select style="width: 100%" v-model="formData.memberCardId" placeholder="请选择">

          </el-select>
        </el-form-item>
        <el-form-item label="推荐人">
          <el-input v-model="formData.recommendCode" placeholder="请输入推荐码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  import utils from "../../utils/utils"
  import { CodeToText,regionData } from 'element-china-area-data'
    export default {
      name: "member-list",
      data(){
          let idCardValidator = (rule, value, callback) => {
            const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
            if(!reg.test(value)){
              callback(new Error("请输入正确的身份证号码"));
            }else{
              callback()
            }
          };
        let iphoneValidator = (rule, value, callback) => {
          const reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
          if(!reg.test(value)){
            callback(new Error("请输入正确的手机号码"));
          }else{
            callback()
          }
        };
          return{
            defaultHeadPicSrc:require('../../assets/person-3.png'),
            provinceAndCityAndCountyOption:regionData,
            deptList:[{
              label:this.getCookie("deptName"),
              value:this.getCookie("deptId")
            }],
            searchForm:{

            },
            tableData:[],
            pageInfo:{
              currentPage:1,
              pageSize:20,
              total:0
            },
            dialogTitle:"",
            dialogVisible:false,
            formData:{
              name:"",
              sex:"1",
              birthDate:"",
              idCard:"",
              iphone:"",
              provinceAndCityAndCounty:[],
              detailAddress:"",
              deptId:this.getCookie("deptId"),
              memberCardId:null,
              recommendCode:""
            },
            rules:{
              name:[
                {required: true, message: '请输入名称，10字以内', trigger: 'blur'},
                {min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur'}
              ],
              sex:[{required: true, message: '请选择性别', trigger: 'change'}],
              idCard:[{required: true, message: '请输入身份证号', trigger: 'blur'},
                {validator:idCardValidator, trigger: 'blur'}],
              iphone:[{required: true, message: '请输入联系电话', trigger: 'blur'},
                {validator:iphoneValidator, trigger: 'blur'}],
              provinceAndCityAndCounty:[{required: true, message: '请选择省市县', trigger: 'change'}],
              detailAddress:[{required: true, message: '请输入详细地址', trigger: 'blur'}],
            },
            photoFile:null,
            fileImageList:[],
            action:"",
            rowId:null
          }
      },
      created(){
        this.getData();
      },
      methods:{
        getData(){
          const loading = this.$loading({
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0)'
          });
          utils.axiosMethods({
            method:"POST",
            params:{
              currentPage:this.pageInfo.currentPage,
              pageSize:this.pageInfo.pageSize
            },
            data:{

            },
            url:"/api/supuMember/getSupuMemberListByPage",
            callback:(res => {
              loading.close();
              if(res.data.code == 0){
                this.tableData = res.data.list;
                this.pageInfo.total = res.data.total;
              }
            }),
            catch:(error => {
              loading.close();
            })
          })
        },
        //每页展示数据条数改变
        handleSizeChange(val){
          this.pageInfo.pageSize = val;
          this.getData();
        },
        //页码改变
        handleCurrentChange(val){
          this.pageInfo.currentPage = val;
          this.getData();
        },
        onCreate(){
          this.dialogVisible = true;
          this.dialogTitle = "添加会员";
          this.action = "add";
        },
        editRow(row){
          this.dialogVisible = true;
          this.dialogTitle = "编辑会员";
          this.action = "edit";
          this.formData = {
            name:row.name,
            sex:row.sex,
            birthDate:new Date(row.birthDate),
            idCard:row.idCard,
            iphone:row.iphone,
            provinceAndCityAndCounty:[row.province,row.city,row.county],
            detailAddress:row.detailAddress,
            deptId:this.getCookie("deptId"),
            memberCardId:row.memberCardId,
            recommendCode:row.recommendCode
          }
          if(row.photo){
            this.fileImageList = [{url:'/api/'+row.photo}]
          }
          this.rowId = row.id;
        },
        deleteRow(row){
          utils.axiosMethods({
            method:"GET",
            params:{
              id:row.id
            },
            url:"/api/supuMember/deleteSupuMember",
            callback:(res => {
              if(res.data.code == 0){
                this.$message.success(res.data.msg);
                this.getData();
              }else{
                this.$message.error(res.data.msg);
              }
            })
          })
        },
        handleClose(){
          this.dialogVisible = false;
          this.formData = {
            name:"",
            sex:"1",
            birthDate:"",
            idCard:"",
            iphone:"",
            provinceAndCityAndCounty:[],
            detailAddress:"",
            deptId:this.getCookie("deptId"),
            memberCardId:null,
            recommendCode:""
          }
          this.fileImageList = [];
        },
        submitForm(){
          //验证表单
          this.$refs["form"].validate((valid) => {
            if (valid) {
              let url,formData = new FormData();
              if(this.photoFile != null){
                formData.append("file",this.photoFile)
              }
              formData.append("name",this.formData.name);
              formData.append("sex",this.formData.sex);
              formData.append("birthDate",this.formData.birthDate);
              formData.append("idCard",this.formData.idCard);
              formData.append("iphone",this.formData.iphone);
              formData.append("province",this.formData.provinceAndCityAndCounty[0]);
              formData.append("city",this.formData.provinceAndCityAndCounty[1]);
              formData.append("county",this.formData.provinceAndCityAndCounty[2]);
              formData.append("detailAddress",this.formData.detailAddress);
              formData.append("deptId",this.formData.deptId);
              if(this.formData.memberCardId){
                formData.append("memberCardId",this.formData.memberCardId);
              }
              formData.append("recommendCode",this.formData.recommendCode);

              if(this.action == "add"){
                // 新增
                url = "/api/supuMember/insertSupuMember";
              }else{
                // 编辑
                formData.append("id",this.rowId);
                url = "/api/supuMember/updateSupuMember";
              }
              const loading = this.$loading({
                lock: true,
                text: '加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
              });
              utils.axiosMethods({
                method:"POST",
                url:url,
                data:formData,
                callback:(res =>{
                  if(res.data.code == 0){
                    this.getData();
                    this.handleClose();
                    this.$message.success(res.data.msg);
                  }else{
                    this.$message.error(res.data.msg);
                  }
                  loading.close();
                }),
                catch:(error =>{
                  this.$message.error(error.response.data.message);
                  loading.close();
                })
              })
            }
          })
        },
        //图片上传方法
        handleUploadSuccess(file, fileList){
          this.photoFile = file.raw;
        },
        handleRemove(file) {
          this.photoFile = null;
          this.fileImageList = [];
        },
        addressMatter(row, column, cellValue, index){
          let address="";
          if(row.province){
            address += CodeToText[row.province]
          }
          if(row.city) {
            address += CodeToText[row.city]
          }
          if(row.county) {
            address += CodeToText[row.county]
          }
          if(row.detailAddress){
            address += row.detailAddress
          }
          return address;
        },
        dateMatter(row, column, cellValue, index){
          return utils.dateFormat(cellValue)
        }
      }
    }
</script>

<style scoped lang="less">
  .block{
    float: right;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/supu/memberList.vue